import type { Query, QueryClient } from '@tanstack/react-query';

// Query-key prefixes whose entries carry a workspace scope in queryKey[1].workspace_id.
const WORKSPACE_SCOPED_KEY_PREFIXES = [
  'GetPdp',
  'SearchPdps',
  'SearchImages',
  'SearchPdpImages',
  'GetImage',
  'GetImageOrder',
  'GetImageCount',
  'GetImageMix',
  'GetImageScores',
  'GetRecommendations',
  'GetCollection',
  'SearchCollections',
  'SearchCollectionImages',
  'SearchBenchmarks',
  'GetBenchmark',
  'ListBenchmarkImages',
  'ListCollectionImageClassifications',
  'GetPortfolioBrands',
  'GetArtifact',
  'GetIdea',
  'SearchIdeas',
  'GetBulkImport',
  'GetBulkRefreshJob',
  'ExportPdpsCsv',
  'GetOriginalPdpSnapshot',
  'GetProductCategories',
] as const;

export function isWorkspaceScopedQuery(query: Query): boolean {
  const key = query.queryKey[0];
  if (typeof key !== 'string') {
    return false;
  }

  const isScopedPrefix = WORKSPACE_SCOPED_KEY_PREFIXES.some((prefix) => key.startsWith(prefix));
  if (!isScopedPrefix) {
    return false;
  }

  const variables = query.queryKey[1];
  return typeof variables === 'object' && variables !== null && 'workspace_id' in variables;
}

export function removeWorkspaceScopedQueries(queryClient: QueryClient, workspaceId: string): void {
  queryClient.removeQueries({
    predicate: (query) => {
      if (!isWorkspaceScopedQuery(query)) {
        return false;
      }
      const variables = query.queryKey[1] as { workspace_id?: string };
      return variables.workspace_id === workspaceId;
    },
  });
}
